module.exports = __webpack_public_path__ + "img/yinle2.d20b351c.png";